import { useEffect, useState } from "react";

import { ProductType } from "@type/inventory/procurements";
import { getProductDetails } from "@api/inventory/productDetails";

type Products = {
  [kay: string]: any;
  error: any;
  isLoading: boolean;
  getData: ProductType | null;
};

export const useProductDetails = (id_2: string): Products => {
  const [products, setProducts] = useState<Products>({
    getData: null,
    error: null,
    isLoading: false,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setProducts((prev: Products) => ({
          ...prev,
          isLoading: true,
        }));
        const res = await getProductDetails(id_2);

        setProducts((prev: Products) => ({
          ...prev,
          isLoading: false,
          getData: res.data,
        }));
      } catch (err) {
        setProducts((prev: Products) => ({
          ...prev,
          isLoading: false,
          getData: null,
          error: err,
        }));
      }
    };

    if (id_2) {
      fetchData();
    }
  }, [id_2]);

  return products;
};
